import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLotteryRound } from "../features/lotteryReducer";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { getIconHuay } from "../helper/Colorhuaycard";
import {
  getSocketYeekeeResult,
  SocketResultHuay,
  disconnectHuayYak,
} from "../features/lotteryReducer";
import { useNavigate } from "react-router-dom";
import PreviousBar from "../component/PreviousBar";

const LatestCard = (props) => {
  const [number1, setNumber1] = useState("0");
  const [number2, setNumber2] = useState("0");
  const [number3, setNumber3] = useState("0");
  const [number4, setNumber4] = useState("0");
  const [number5, setNumber5] = useState("0");
  const [check, setCheck] = useState(true);
  useEffect(() => {
    if (props.langNum != null && props.bonNum != null) {
      if (check == true) {
        const result1 = props.langNum.split("");
        const result2 = props.bonNum.split("");
        setNumber1(result1[0]);
        setNumber2(result1[1]);
        setNumber3(result2[0]);
        setNumber4(result2[1]);
        setNumber5(result2[2]);
      } else {
        const result1 = props.langNum.split("");
        const result2 = props.bonNum.split("");
        setTimeout(() => {
          setNumber1(result1[0]);
        }, 1000);
        setTimeout(() => {
          setNumber2(result1[1]);
        }, 3000);
        setTimeout(() => {
          setNumber3(result2[0]);
        }, 5000);
        setTimeout(() => {
          setNumber4(result2[1]);
        }, 7000);
        setTimeout(() => {
          setNumber5(result2[2]);
        }, 9000);
      }
    } else {
      setNumber1("r");
      setNumber2("r");
      setNumber3("r");
      setNumber4("r");
      setNumber5("r");
      setCheck(false);
    }
  }, [props]);

  const Slot = (props) => {
    return props.value != "r" ? (
      <ResultSlot value={props.value} />
    ) : (
      <TestSlot />
    );
  };

  const ResultSlot = (props) => {
    return (
      <div className="overflow-y-hidden inline-block border rounded bg-white text-[#b3853e] h-10 relative">
        <ul className="p-0 m-0 list-none  float-left text-center w-10 h-10 text-4xl font-bold">
          <li className="align-top text-center ">{props.value}</li>
        </ul>
      </div>
    );
  };

  const TestSlot = () => {
    const Random = () => {
      var temp = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
      var arr = [];
      for (var i = 0; i <= 9; i++) {
        arr.push(temp[Math.floor(Math.random() * temp.length)]);
        temp = temp.filter((data) => !(data == arr[i]));
      }
      return arr;
    };

    const num = Random();
    return (
      <div className="overflow-y-hidden inline-block border rounded bg-white text-[#b3853e] h-10 relative">
        <ul className="p-0 m-0 list-none  float-left text-center w-10 h-10 animate-test text-4xl font-bold">
          {num.map((data, i) => (
            <li key={i} className="align-top text-center ">
              {data}
            </li>
          ))}
        </ul>
        <ul className="p-0 m-0 list-none absolute float-left text-center w-10 h-10 animate-test2 text-4xl">
          {num.map((data) => (
            <li className="align-top text-center ">{data}</li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="rounded bg-[#b3853e] w-auto text-center text-[#f8eede] col-span-2 pt-1">
      <div className="flex justify-center">
        <img
          src={getIconHuay(props.name.replace(" SUPER", ""))}
          layout={"fixed"}
          width={40}
          height={40}
        />
        <span className="text-base inline-block ml-2 pt-2 text-[#f8eede]">
          ผลหวย{props.name}{" "}
          {props.name == "จับยี่กี" ? "(ออกทุก 15นาที)" : "(ออกทุก 5นาที)"}{" "}
        </span>
      </div>

      <div className="flex justify-between mt-2">
        <div className="bg-defaultTabsAndPoyColor px-3 mb-4 text-base">
          รอบที่ {props.round}
        </div>
        <div className="pb-1 mr-1 grid grid-cols-5 gap-0.5">
          <Slot value={number1} i={0} />
          <Slot value={number2} i={1} />
          <Slot value={number3} i={2} />
          <Slot value={number4} i={3} />
          <Slot value={number5} i={4} />
        </div>
      </div>
    </div>
  );
};

const NormalCard = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [state, setState] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const Countdown = (props) => {
    useEffect(() => {
      const id = setInterval(() => {
        const currentTime = new Date().getTime();
        const distanceToDate =
          new Date(props.closeSale).getTime() - currentTime;

        let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor(
          (distanceToDate % (1000 * 60 * 60)) / (1000 * 60)
        );
        let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

        const numbersToAddZeroTo = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

        days = `${days}`;
        if (numbersToAddZeroTo.includes(hours)) {
          hours = `0${hours}`;
        }
        if (numbersToAddZeroTo.includes(minutes)) {
          minutes = `0${minutes}`;
        }
        if (numbersToAddZeroTo.includes(seconds)) {
          seconds = `0${seconds}`;
        }

        if (props.group == "Yeekee") {
          setState({ text: "เปิดรับแทง" });
        } else {
          if (hours < 0 && minutes < 0 && seconds < 0) {
            if (props.index == "0") {
              dispatch(getLotteryRound());
            }
            setState({ text: "ปิดรับแทง" });
          } else {
            setState({
              days: days,
              hours: hours,
              minutes: minutes,
              seconds: seconds,
            });
          }
        }
      }, 1000);
      return () => {
        clearInterval(id);
      };
    }, []);

    return (
      <p className="   text-lg">
        {state.text
          ? state.text
          : state.days == 0
          ? state.hours + ":" + state.minutes + ":" + state.seconds
          : state.days +
            "วัน " +
            state.hours +
            ":" +
            state.minutes +
            ":" +
            state.seconds}
      </p>
    );
  };

  const onClick = () => {
    localStorage.setItem("roundId", props.roundId);
    localStorage.setItem("closeRoundDatetime", props.closeSale);
    localStorage.setItem("Round", props.round);
    navigate(`/playlottery`);
  };

  return (
    <button
      className={`w-auto bg-[#b3853e] rounded text-base text-[#f8eede] ${
        state.text ? `filter grayscale ` : ``
      }`}
      disabled={state.text ? true : false}
      onClick={onClick}
    >
      <div className="flex justify-between my-1 text-defaultTabsAndPoyTextColor">
        <p className="px-2 bg-defaultTabsAndPoyColor1 ">รอบที่ {props.round}</p>
        <p className="mr-1 font-bold">{props.name}</p>
      </div>
      <div className="flex justify-end">
        <span className="flex text-end font-bold px-2 mx-1 w-auto bg-[#f8eede] rounded text-xs md:text-sm text-[#b3853e]">
          ปิดแทง {props.close}
        </span>
      </div>
      <div className="w-auto bg-white border rounded  py-1 mt-1 px-1 flex justify-between text-green-600">
        <AccessAlarmIcon />
        <Countdown index={props.index} closeSale={props.closeSale} />
      </div>
    </button>
  );
};

const Chooseround = () => {
  const dispatch = useDispatch();
  const lotteryRound = useSelector((state) => state.lottery.lotteryRound);
  // const [room, setRoom] = useState(false)
  // console.log(lotteryRound)
  useEffect(() => {
    disconnectHuayYak();
    dispatch(getLotteryRound());

    // if (!room) {
      SocketResultHuay();
      // setRoom(true);
      dispatch(getSocketYeekeeResult());
    // }
  }, []);
  
  return (
    <>
      <PreviousBar name="เลือกรอบหวย" />
      <div className="mt-2 px-1 grid gap-2 grid-cols-2 md:grid-cols-4">
        {lotteryRound?.data[0] ? (
          <LatestCard
            key={0}
            round={lotteryRound?.data[lotteryRound.data.length - 1].roundNumber}
            name={lotteryRound?.data[lotteryRound.data.length - 1].lotteryName}
            langNum={
              lotteryRound?.data[lotteryRound.data.length - 1].results.length
                ? lotteryRound?.data[lotteryRound.data.length - 1].results.find(
                    (result) => result.betType == "lang_2"
                  ).betNumber
                : null
            }
            bonNum={
              lotteryRound?.data[lotteryRound.data.length - 1].results.length
                ? lotteryRound?.data[lotteryRound.data.length - 1].results.find(
                    (result) => result.betType == "bon_3"
                  ).betNumber
                : null
            }
          />
        ) : (
          <></>
        )}

        {lotteryRound ? (
          lotteryRound.data.map((round, i) =>
            i != lotteryRound.data.length - 1 ? (
              <NormalCard
                key={i}
                index={i}
                round={round.roundNumber}
                name={round.lotteryName}
                roundId={round._id}
                closeSale={round.closeSaleDatetime}
                close={new Date(round.closeSaleDatetime).toLocaleTimeString(
                  "th-TH",
                  { hour: "2-digit", minute: "2-digit" }
                )}
              />
            ) : (
              <></>
            )
          )
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default Chooseround;
